import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TimeOffForm from './TimeOffForm.jsx'
//import _ from 'lodash'

class AddTimeOffComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.vacation.vacation) {
      return <div><TimeOffForm vacation={this.props.vacation}></TimeOffForm></div>
    }
    return <div></div>
  }
}

AddTimeOffComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  vacation: PropTypes.object.isRequired,
}

export default AddTimeOffComponent
